import styled, { keyframes } from "styled-components";

const marqueeScroll = (distance: number) => keyframes` 
0% { transform: translateX(0px); } 
100% { transform: translateX(${distance}px); } `;

interface IndexReviewsComponentReviewsSectionProp {
  length: number;
  itemwidth: number;
  gap: number;
  reverse?: boolean;
}
export const IndexReviewsComponentMainDiv = styled.section`
  > div {
    display: flex;
    flex-direction: column;
    gap: 60px;
    padding: 100px 40px;
    align-items: center;
  }
  .reviews-background {
    position: absolute;
  }
    
  .review-button-container {
    display: flex;
    min-width: 160px;
    max-width: 160px;

  }
  .reviews-container {
    display: flex;
    flex-direction: column;
    gap: 60px;
    width: 100%;
    max-width: 1140px;
  }
  .reviews-header {
    display: flex;
    flex-direction: column;
    width: 100%;
    flex: 1;
    gap: 16px;
  }
  .reviews-header-text-container {
    max-width: 723px;
    > h2 {
      font-size: 65px;
      line-height: 1em;
    }
  }
  .reviews-content-holder {
    overflow: hidden;
  }
`;

export const IndexReviewsComponentReviewsSection = styled.div<IndexReviewsComponentReviewsSectionProp>`
  .reviews-section-container {
    flex-flow: row;
    align-items: center;
    gap: 0;
    width: 100%;
    margin: 0 auto;
    max-width: 1200px;
    height: min-content;
    display: flex;
    position: relative;
    overflow: visible;
    > div {
      display: flex;
      width: 100%;
      flex: 1;
    }
  }

  .review-section-holder {
    flex-flow: column;
    flex: 1 0 0;
    place-content: center;
    align-items: center;
    gap: 32px;
    width: 1px;
    max-width: 1140px;
    height: min-content;

    padding: 0;
    display: flex;
    position: relative;
    overflow: hidden;
    > div {
      display: flex;
      width: 100%;
      flex: 1;
    }
  }
  .reviews-marque-container {
    width: 100%;
    cursor: pointer;
    position:relative > div {
      flex-flow: row;
      place-content: center;
      align-items: center;
      gap: 0;
      width: 100%;
      height: min-content;
      padding: 0;
      display: flex;
      position: relative;
      overflow: visible;
    }
    .reviews-marque-gradient-cover {
      width: 60px;
      position: absolute;
      top: 0;
      z-index: 1;
      bottom: 0;
    }
    .reviews-marque-gradient-cover-left {
      left: 0;
      background: linear-gradient(
        90deg,
        rgb(0, 0, 0) 0%,
        rgba(0, 0, 0, 0) 100%
      );
    }
    .reviews-marque-gradient-cover-right {
      right: 0;
      background: linear-gradient(
        270deg,
        rgb(0, 0, 0) 0%,
        rgba(0, 0, 0, 0) 100%
      );
    }

    .reviews-marque-scroll-holder {
      flex: 1 0 0;
      width: 1px;
      height: min-content;
      position: relative;
      padding: 4px > section {
        display: flex;
        width: 100%;
        height: 100%;
        max-width: 100%;
        max-height: 100%;
        place-items: center;
        margin: 0px;
        padding: 0px;
        list-style-type: none;
        opacity: 1;
        overflow: hidden;
      }
    }
    .reviews-marque-scroll-list {
      list-style-type: none;
      display: flex;
      width: 100%;
      height: 100%;
      max-width: 100%;
      max-height: 100%;
      align-items: center;
      margin: 0px;
      padding: 0px;
      gap: 60px;
      position: relative;
      flex-direction: row;
      align-items:stretch;
      justify-content: ${(p) => (p.reverse ? "flex-end" : "flex-start")};
      transform: translateX(
        ${(p) =>
          (p.gap * p.length + p.itemwidth * p.length) * (p.reverse ? 1 : -1)}px
      );
      animation: ${({ gap, length, itemwidth, reverse }) =>
       marqueeScroll((gap * length + itemwidth * length) * (reverse ? 1 : -1))}
        70s linear infinite;
      &:hover {
        animation-play-state: paused;
      }
    }
  }
`;

export const IndexReviewsComponentReviewItesmDiv = styled.li`
  flex-shrink: 0;
  width: 364px;
    flex-grow: 1;

  display:flex;

  > div {
   flex:1;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    width: 364px;
    padding: 40px;
    align-items: center;
    justify-content: space-between;
    gap: 110px;
    backdrop-filter: blur(10px);

    background: #ffffff05;
    border-radius: 14px;
    border: 1px solid #ffffff24;
  }
  .review-item-top {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  .review-item-icon {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    > svg {
      width: 40px;
      height: 40px;
    }
  }

  .review-text-holder {
    > p {
      padding: 0;
      font-size: 18px;
      font-weight: 500;
      line-height: 1.3em;
    }
  }
  .review-item-pfp {
    background: #000;
    border-radius: 8px;
    overflow: hidden;
    width: 60px;
    height: 60px;
    > img {
      border-radius: 8px;
    }
  }
  .review-item-bottom {
    display: flex;
    width: 100%;
    gap: 16px;
    align-items: center;
  }
  .review-texts-container {
    display: flex;
    gap: 4px;
    flex-direction: column;
  }
  .review-name-container {
    > p {
      font-family: "Inter", "Inter Placeholder", sans-serif;
      font-size: 16px;
      line-height: 1.4em;

      font-weight: 500;
    }
  }

  .review-posotion-container {
    > p {
      font-family: "Inter", "Inter Placeholder", sans-serif;
      font-size: 13px;
      font-weight: 400;
      line-height: 1.4em;
    }
  }
`;
